<template>
  <div class="page-header" :style="backgroundStyle">
    <div class="container">
      <h1>{{ title }}</h1>
      <p v-if="subtitle">{{ subtitle }}</p>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "PageHeader",
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      default: ""
    },
    backgroundImage: {
      type: String,
      default: ""
    }
  },
  computed: {
    backgroundStyle() {
      if (this.backgroundImage) {
        return {
          backgroundImage: `linear-gradient(rgba(1, 87, 155, 0.7), rgba(1, 87, 155, 0.9)), url(${this.backgroundImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        };
      }
      return {};
    }
  }
};
</script>

<style lang="scss" scoped>
.page-header {
  background-color: var(--primary, #01579b);
  padding: 60px 0;
  color: white;
  text-align: center;
  
  .container {
    max-width: 1240px;
    margin: 0 auto;
    padding: 0 20px;
  }
  
  h1 {
    font-size: 36px;
    margin-bottom: 15px;
    font-weight: 600;
  }
  
  p {
    font-size: 18px;
    max-width: 800px;
    margin: 0 auto;
    opacity: 0.9;
  }
}

@media screen and (max-width: 768px) {
  .page-header {
    padding: 40px 0;
    
    h1 {
      font-size: 28px;
    }
    
    p {
      font-size: 16px;
    }
  }
}
</style>
